import React from 'react';

function CatchurisPage() {
  return <div>Catchuris</div>;
}

export default CatchurisPage;
